'use strict';

var createVisualElement = require('../../dom/create-visual-element.cjs');
var createProxy = require('../create-proxy.cjs');
var featureBundle = require('./feature-bundle.cjs');

const motion = /*@__PURE__*/ createProxy.createMotionProxy(featureBundle.featureBundle, createVisualElement.createDomVisualElement);

exports.motion = motion;
//# sourceMappingURL=proxy.cjs.map
